export default "__VITE_ASSET__4b6f43b8__"